"use strict";

import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Joi, Validation } from 'react-validation-decorator';
import { SessionStore } from '../../../stores';
import { ConferenceActions } from '../../../actions';

class OneToOneForm extends React.Component {
  constructor(props) {
    const sessionUser = SessionStore.getSessionUser();
    super(props);
    this.state = {
      firstName: sessionUser && sessionUser.firstName || '',
      lastName: sessionUser && sessionUser.lastName || '',
      email: sessionUser && sessionUser.email || '',
      questions: [{question:''}],
      sessionUser:sessionUser
    };
    this._handleInputChange = this._handleInputChange.bind(this);
  };

  validationSchema = Joi.object().keys({
    firstName: Joi.string().required().label('First Name'),
    lastName: Joi.string().required().label('Last Name'),
    email: Joi.string().email().lowercase().required().label('Email'),
    questions: Joi.array().optional(),
  });
  componentDidMount(){
    let payload = {
      nextScreen: 'one2one',
      selectedMentorId:this.props.selectedMentor,
      email:this.state.email,
      isRequestFromWebapp:true
    }
    ConferenceActions.oneToOneConferenceDetailsOfUser(payload,(err,data)=>{
      if(!err){
        let questions = [];
        data.questions.forEach(q => {
          questions.push({question:q.title})
        });
        this.setState({questions});
      }
    })
  }
  render() {
    let { questions } = this.state;
    return (
      <form name="oneToOneForm" noValidate >
        <Row>
        <Col md={12}>
            <div className={this.getValidationClassName('email')}>
              <label>Email</label>
              <input disabled={this.state.sessionUser && this.state.sessionUser.email ? true : false} type='email' className='form-control'
                value={this.state.email}
                placeholder="Enter Email..."
                onChange={this._handleInputChange.bind(this, 'email')} />
              {this.renderValidationMessages('email')}
            </div>

          </Col>
          <Col md={12}>
            <div className={this.getValidationClassName('firstName')}>
              <label>First Name</label>
              <input disabled={this.state.sessionUser && this.state.sessionUser.email ? true : false} type='text' className='form-control'
                value={this.state.firstName}
                placeholder="Enter First Name..."
                onChange={this._handleInputChange.bind(this, 'firstName')} />
              {this.renderValidationMessages('firstName')}
            </div>
          </Col>
          <Col md={12}>
            <div className={this.getValidationClassName('lastName')}>
              <label>Last Name</label>
              <input disabled={this.state.sessionUser && this.state.sessionUser.email ? true : false} type='text' className='form-control'
                value={this.state.lastName}
                placeholder="Enter Last Name..."
                onChange={this._handleInputChange.bind(this, 'lastName')} />
              {this.renderValidationMessages('lastName')}
            </div>
          </Col>


          {questions.map((q, idx) => {
            return (<Col md={12} key={`question${idx}`}>
              <div className={this.getValidationClassName('questions')}>
                <label>Questions { idx > 0 && <i title={'Delete Question'} style={{cursor:'pointer'}} className="fa fa-trash text-danger" onClick={() => {
                let questions = this.state.questions;
                questions.splice(idx,1);
                this.setState({questions}, () => {
                  this.validate('questions');
                  this._isFormValid();
                })
              }} ></i>} </label>
                <input type='text' className='form-control'
                  value={q.question}
                  placeholder="Question..."
                  onChange={(event) => {
                    let questions = this.state.questions;
                    questions[idx].question =  event.target.value;
                    this.setState({questions}, () => {
                      this.validate('questions');
                      this._isFormValid();
                    })
                  }} />
                {this.renderValidationMessages('questions')}
              </div>
              
            </Col>)
          })
          
        }
        <Col md={12}>
        <button style={{marginBottom:'10px'}} type='button' className='btn btn-primary' onClick={(e)=>{
          let questions = this.state.questions;
          questions.push({question:''});
          this.setState({questions}, () => {
            this.validate('questions');
            this._isFormValid();
          })
        }}>Add Question</button>
        </Col>
        </Row>
      </form>
    );
  };

  _handleInputChange(formInput, event) {
    let value = event.target.value;
    this.setState(state => {
      state[formInput] = value;
    }, () => {
      this.validate(formInput);
      this._isFormValid();
    });
  };

  _isFormValid() {
    this.props.isValid(!this.state.validation.errors.length);
  };

  getModel() {
    return this.state.validation.value;
  };
}

export default Validation(OneToOneForm);
